var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.327,
    height: 12.574,
    viewBox: "0 0 23.327 12.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Proof_of_delivery_",
    "data-name": " Proof of delivery ",
    transform: "translate(-151.052 -254.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M191.133,311.538l-2.309-.319-.933-2.382a1.66,1.66,0,0,0-1.621-1.032h-2.677a.429.429,0,0,0-.442.368l-.884,4.887a.447.447,0,0,1-.442.368H170.086a.429.429,0,0,0-.442.368l-.246,1.4a.467.467,0,0,0,.442.54h.958a1.667,1.667,0,0,0,1.695,1.891,2.59,2.59,0,0,0,2.382-1.891h10.683a1.667,1.667,0,0,0,1.695,1.891,2.567,2.567,0,0,0,2.382-1.891h1.154a.429.429,0,0,0,.442-.368l.516-2.922a.716.716,0,0,0-.614-.909Zm-17.192,4.028a1.338,1.338,0,0,1-1.277,1.081.876.876,0,0,1-.884-1.081,1.338,1.338,0,0,1,1.277-1.081A.876.876,0,0,1,173.941,315.566Zm10.143-4.421.368-2.063h1.572a.647.647,0,0,1,.614.393l.663,1.67Zm4.617,4.421a1.338,1.338,0,0,1-1.277,1.081.866.866,0,0,1-.884-1.081,1.338,1.338,0,0,1,1.277-1.081A.876.876,0,0,1,188.7,315.566Z",
    transform: "translate(-17.389 -50.283)",
    fill: "#727376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M164.338,262.115l1.2-6.8a.467.467,0,0,0-.442-.54H153.385a.761.761,0,0,0,0,1.523h1.277a.761.761,0,1,1,0,1.523H152.6a.761.761,0,1,0,0,1.523h1.277a.765.765,0,0,1,.761.761.8.8,0,0,1-.761.786h-2.063a.761.761,0,1,0,0,1.523h12.059a.334.334,0,0,0,.467-.295Z",
    fill: "#727376"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPod);
export default __webpack_public_path__ + "static/media/pod.179b97ce06c311677e3b5e19521acfcc.svg";
export { ForwardRef as ReactComponent };